import { Box, DashboardModule } from '@domain-group/suit-theme'

import useSelector from '@hooks/useSelector'

import type { UseOrderApprovalPayload } from '@modals/ApproveOrderModal/hooks/useOrderApproval'

import Disclaimer from './Disclaimer'

type DisclaimersProps = {
  orderApprovalPayload: UseOrderApprovalPayload,
}

const Disclaimers = (props: DisclaimersProps) => {
  const {
    orderApprovalPayload: {
      acceptedDisclaimerIds,
      callbacks: { toggleDisclaimerId },
      orderDisclaimers: { ids, requiredIds },
    },
  } = props

  const { providerDisclaimers, serviceProducts } = useSelector(reduxState => reduxState.entities)

  return (
    // @ts-expect-error TS2322
    <DashboardModule direction="column" title="Disclaimers">
      <Box flexDirection="column">
        <Box flexDirection="column" paddingX="large">
          <Disclaimer
            checked
            disclaimerBody="I've checked this order, its artworks and all instructions and understand I'm responsible for any issues or costs encountered due to any or all of the information and artworks provided to Realhub or a third party supplier as a result of the order approval in its current state."
            disclaimerTitle="Order Confirmation"
          />

          {ids.map((disclaimerId) => {
            const disclaimer = providerDisclaimers[disclaimerId] || {}
            // @ts-expect-error TS2339
            const product = disclaimer.entity_type === 'ServiceProduct' ? serviceProducts[disclaimer.entity_id] : {}
            const acceptanceRequired = requiredIds.includes(disclaimerId)
            const checked = !acceptanceRequired || acceptedDisclaimerIds.includes(disclaimerId)

            // @ts-expect-error TS2339
            if (!disclaimer.id){
              return null
            }

            return (
              <Disclaimer
                key={disclaimerId}
                acceptanceRequired={acceptanceRequired}
                checked={checked}
                // @ts-expect-error TS2339
                disclaimerBody={disclaimer.disclaimer_text}
                // @ts-expect-error TS2339
                disclaimerTitle={product.title || 'Product'}
                // @ts-expect-error TS2339
                onClick={() => toggleDisclaimerId(disclaimer.id)}
              />
            )
          })}
        </Box>
      </Box>
    </DashboardModule>
  )
}

export default Disclaimers
